export enum Layout {
  transactionFlow = 'transactionFlow',
  planFinder = 'planFinder',
  centered = 'centered',
}
